interface inconType {
  size?: number;
  color?: string;
}

export const ArrowDown = ({ size = 15, color = "black" }: inconType) => {
  return (
    <svg
      width={size}
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0L5 5L10 0H0Z" fill={color} />
    </svg>
  );
};
